import {EventEmitter} from '@angular/core';

export class Reload {
    private static _reload = new EventEmitter<boolean>();
    static doReload = Reload._reload.asObservable();

    static emitReload() {
        this._reload.emit();
    }
}

